module.exports = __webpack_public_path__ + "static/media/featureShown.e1262d13.png";